import Typography from "@mui/material/Typography";
import { useState } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";

export type FuseLoadingProps = {
  delay?: number;
  className?: string;
  isStart?: boolean;
  
  isheight?: boolean;
};

/**
 * FuseLoading displays a loading state with an optional delay
 */
function ListLoadingNew(props: FuseLoadingProps) {
  const { delay = 0, className, isStart, isheight } = props;
  const [showLoading, setShowLoading] = useState(!delay);

  //   useTimeout(() => {
  //     setShowLoading(true);
  //   }, delay);

  return (
    <StyledContainer className={className} $showLoading={showLoading} $isheight={isheight}>
      {/* <Typography className="loading-text" color="text.secondary">
        Loading
      </Typography> */}
      {/* <StyledSpinner>
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </StyledSpinner> */}
      <CircularProgress />
    </StyledContainer>
  );
}

export default ListLoadingNew;

/* ✅ Styled Components */
const StyledContainer = styled.div<{
  $showLoading: boolean;
  $isStart?: boolean;
  $isheight?: boolean;
}>`
  display: ${({ $showLoading }) => ($showLoading ? "flex" : "none")};
  flex: 1;
  height: ${({ $isheight }) => ($isheight ? "50px" : "87vh")};
  width: 100%;
  align-items: center;
  justify-content: ${({ $isStart }) => ($isStart ? "flex-start" : "center")};
  flex-direction: column;
  padding: 24px;
`;

const StyledSpinner = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  width: 56px;

  & > div {
    width: 12px;
    height: 12px;
    background-color: #2977cc;
    border-radius: 100%;
    display: inline-block;
    animation: bounce-delay 1s infinite ease-in-out both;
  }

  .bounce1 {
    animation-delay: -0.32s;
  }

  .bounce2 {
    animation-delay: -0.16s;
  }

  @keyframes bounce-delay {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;
